import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { dentistsStore } from './redux';

import { FindAPDAppState } from './classes/redux-states';
import FindAPDContainer from './components/find-a-pd-container';

render(
    <Provider store={dentistsStore}>
        <FindAPDContainer />
    </Provider>

	, document.querySelector("[data-find-a-pd]"));




// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/index.tsx